import { render, staticRenderFns } from "./RectangularTrapezoidHorizontal.vue?vue&type=template&id=0fe4a194&scoped=true&"
import script from "./RectangularTrapezoidHorizontal.vue?vue&type=script&lang=js&"
export * from "./RectangularTrapezoidHorizontal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0fe4a194",
  null
  
)

export default component.exports